export const zoomMixin = {
  data() {
    return {
      zoomMix: 100
    }
  },
  methods: {

    getZoomM(){
      return this.zoomMix
    },
    setZoom(val){
      this.canvas.setZoom(val)
    }
  }
}
